export type IsUsSupportUserArgs = {
  isTu: boolean | undefined;
  talentStatus: 'ONE' | 'ZERO' | undefined;
};

/**
 * @returns USサポートユーザーか否か
 */
export function getIsUsSupportUser({
  isTu,
  talentStatus,
}: IsUsSupportUserArgs): boolean {
  return isTu === true && talentStatus === 'ONE';
}
